import { useTranslatedText } from "../contexts/TranslationContext";
import { extraerCodigoMateria, extraerNombreMateria, extraerSeccion } from "../utils";

/** Traduce solo el nombre de la materia y conserva sección y código sin traducir. */
export const useTranslatedSubjectTitle = (title: string | null | undefined) => {
  const source = title ?? "";
  const subjectName = useTranslatedText(extraerNombreMateria(source));
  const seccion = extraerSeccion(source);
  const codigoMateria = extraerCodigoMateria(source);

  if (!source.trim() || !seccion) return subjectName;
  return `${subjectName} - ${seccion}${codigoMateria ? ` ${codigoMateria}` : ""}`;
};
